// @flow
import path from 'ramda/es/path';

import shopApiRequest, { apiCancelable } from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_PRODUCTS_REQUEST = 'SHOP_PRODUCTS_REQUEST';
export const SHOP_PRODUCTS_SUCCESS = 'SHOP_PRODUCTS_SUCCESS';
export const SHOP_PRODUCTS_FAILURE = 'SHOP_PRODUCTS_FAILURE';
export const SHOP_PRODUCTS_CLEAR = 'SHOP_PRODUCTS_CLEAR';
export const SHOP_PRODUCTS_CANCEL = 'SHOP_PRODUCTS_CANCEL';


/**
 * Запрос товаров каталога
 */
export const productsFetch = (slug: string, search?: string) => async (dispatch: Function) => {
  const p = search ? { search } : {};
  const params = { ...p, category_id: slug };
  dispatch(action(SHOP_PRODUCTS_REQUEST, params));
  try {
    const res = await shopApiRequest('products', 'get', { params });
    const data = path(['data', 'data'], res) || [];
    dispatch(action(SHOP_PRODUCTS_SUCCESS, data));
    return { errStatus: 0 };
  } catch (error) {
    const status = path(['response', 'status'], error);
    dispatch(action(SHOP_PRODUCTS_FAILURE, {
      err: 'Запрос товаров каталога не удался',
      slug,
      error,
    }));
    return { errStatus: status };
  }
};

/**
 * Запрос товаров с прерыванием предыдущего (для поиска)
 */
export const productsFetchSearch = (slug: string, search?: string) => async (dispatch: Function) => {
  const p = search ? { search } : {};
  const params = { ...p, category_id: slug };
  dispatch(action(SHOP_PRODUCTS_REQUEST, params));
  try {
    const res = await apiCancelable.request('products', 'get', { params });
    const data = path(['data', 'data'], res) || [];
    dispatch(action(SHOP_PRODUCTS_SUCCESS, data));
    return { errStatus: 0 };
  } catch (error) {
    if (error instanceof Error) {
      const status = path(['response', 'status'], error);
      dispatch(action(SHOP_PRODUCTS_FAILURE, {
        err: 'Запрос товаров каталога не удался',
        slug,
        error,
      }));
      return { errStatus: status };
    }
    dispatch(action(SHOP_PRODUCTS_CANCEL));
    return { errStatus: -1 };
  }
};
